import { render } from "./support-tab.vue?vue&type=template&id=114aed6a&scoped=true"
import script from "./support-tab.vue?vue&type=script&lang=js"
export * from "./support-tab.vue?vue&type=script&lang=js"

import "./support-tab.vue?vue&type=style&index=0&id=114aed6a&lang=scss&scoped=true"

import exportComponent from "/home/rof/src/bitbucket.org/AsokoInsight/virtual-dealroom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-114aed6a"]])

export default __exports__